export default __webpack_public_path__ + "static/images/plugin-rp.png?1234c3d78e970e4adf6c88e31006ddfc";